export default {
  install(Vue) {
    const setLogMessage = log => {
      window.localStorage.setItem('log_message', log)
    }
    Vue.prototype.$setLogMessage = Vue.setLogMessage = setLogMessage
  }
}
